// extracted by mini-css-extract-plugin
export default {"swatch":"_2rhOFuK"};